import React, {useEffect, useState, useMemo, useRef} from 'react'
import { Flex, Title, Icon, TabGroup, TabList, Tab, AreaChart, Text, Color } from "@tremor/react";

import './Analytic.scss'

import {exportInsigths, getAnalytics} from "../../../actions/requests";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {CSRF, filterList, getIcon} from "../../../constants";
import { ResponsiveLine } from '@nivo/line'
import { ResponsiveBar } from '@nivo/bar'
import { TooltipWrapper } from '@nivo/tooltip';
import DateRangePicker from "react-date-range/dist/components/DateRangePicker";
import {defaultStaticRanges} from "../../../constants";
import 'react-calendar/dist/Calendar.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendar, faXmark} from "@awesome.me/kit-a13c95776b/icons/modules/sharp/thin";
import {TabPanel} from "react-tabs";
import { timeFormat } from 'd3-time-format'
import { scaleTime } from 'd3-scale'
import {addDays, startOfWeek, endOfWeek} from "date-fns";
import {faBars, faFileExport} from "@fortawesome/free-solid-svg-icons";
import ModalWindow from "../ModalWindow";
import Button from "../Button";

const Analytics = (props) => {

    const dispatch = useDispatch()
    const [selectedIndex, setSelectedIndex] = useState(0)
    const {id: pageId} = useSelector(state => state.pages.facebook.activePage.details)
    const user = useSelector(state => state.user)
    const {profile} = user
    const {sub_users, week_starts_on, email} = profile.attributes
    const [data, setData] = useState([])
    const keys = ["Visible", "Hidden", "Deleted"];
    const colors = ['#0c9f647a', '#2bae76', '#f47560']
    const [totalData, setTotalData] = useState()
    const [showExportModal, setShowExportModal] = useState(false)
    const [load, setLoad] = useState(false)
    const exportForm = useRef()
    const directType = useRef()

    const [startDate, setStartDate] = useState(startOfWeek(new Date(), {weekStartsOn: week_starts_on}))
    const [endDate, setEndDate] = useState(endOfWeek(new Date(), {weekStartsOn: week_starts_on}))
    const [staticRange, setStaticRange] = useState(false)
    const [userFilter, setUserFilter] = useState()
    const dropdownRef = useRef()

    const handleStaticRange = () => {
        setStaticRange(true)
    }

    const callAnalytics = (dates, userId=null) => {
        axios.post(`/analytics`, {page_id: pageId, dates: dates, user_id: userId === "clear" ? null : (userId || userFilter?.id)}, {headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': CSRF}})
            .then(json => {
                if(json.data[0].data?.length > 0) {
                    setTotalData([{name: "Total comments", value: json.data[0].total_comments},
                        {name: "Total visible", value: json.data[0].total_visible},
                        {name: "Total hidden", value: json.data[0].total_hidden},
                        {name: "Total deleted", value: json.data[0].total_deleted}])
                }else{
                    setTotalData([])
                }
                setData(json.data)
            }).catch(error => {
        })
    }

    useEffect(()=>{
        callAnalytics([formatter_submit(startDate), formatter_submit(endDate)])
    },[pageId])

    const formatter = timeFormat('%m-%d-%Y')
    const formatter_submit = timeFormat('%d-%m-%Y')
    const formatter_alt = timeFormat('%b %d, %Y')
    const timeScaleTicks = useMemo(() => {
        if(endDate) {
            const scaleS = scaleTime().domain([startDate, endDate])
            const ticks = scaleS.ticks(10)
            return ticks.map((tick) => {
                return formatter(tick)
            })
        }
    },[endDate])

    const tickFormat = (d) => {
        var date = new Date(d);
        if (date.getHours() == 0){
            return timeFormat('%-M min')(d)
        } else {
            if (date.getMinutes() == 0){
                return timeFormat('%-S sec')(d)
            }else{
                return timeFormat('%-H h %-M min')(d)
            }
        }

    }

    const isMobile = /Mobi|Android/i.test(navigator.userAgent)

    useEffect(()=>{
        const divs = document.querySelectorAll('.rdrStaticRange');
        divs.forEach(el => el.addEventListener('click', handleStaticRange));
        return () => {
            divs.forEach(el => el.removeEventListener('click', handleStaticRange));
        }
    },[])

    const handleSelect = (date) => {
        setRange([date.selection])
        if(date.selection.startDate.getTime()!==date.selection.endDate.setHours(0, 0, 0, 0)) {
            setEndDate(date.selection.endDate)
            setStartDate(date.selection.startDate)
            callAnalytics([formatter_submit(date.selection.startDate), formatter_submit(date.selection.endDate)])
            dropdownRef.current.classList.remove('show')
        }
    }

    const [range, setRange] = useState([
        {
            startDate: startDate || new Date(),
            endDate: endDate || startDate || new Date(),
            key: 'selection'
        }
    ]);

    const handleExport = (e) => {
        e.preventDefault()
        directType.current.checked && setLoad(true)
        dispatch(exportInsigths(exportForm.current, [formatter_submit(startDate), formatter_submit(endDate)], setLoad, setShowExportModal, directType.current.checked))
        !directType.current.checked && setShowExportModal(false)
    }

    const handleUserFilter = (subUser) => {
        setUserFilter(subUser)
        callAnalytics([formatter_submit(startDate), formatter_submit(endDate)], subUser.id)
    }

    const clearUserFilter = (e) => {
        setUserFilter()
        callAnalytics([formatter_submit(startDate), formatter_submit(endDate)], "clear")
    }

    return (
        <div className="analytics">
            <div className="my-4">
                Here you can get statistics and insights about the comments you have received.
                {/*<div className="mt-1 fs-08"><a href="https://tally.so/r/mKKx28" target="_blank">How can we improve our insights?</a></div>*/}
            </div>
            <div className="line"/>
            <div className="row">
                <div className="col-sm-6 d-inline-flex">
                    <div className="d-inline-flex my-4">
                        {data[0]?.data?.length <= 0 ?
                            <div className="align-self-center">
                                Nothing to see here…
                            </div>
                        :
                            <div>
                                <button className="btn btn-exp" onClick={()=>setShowExportModal(true)}>
                                    Export
                                    <FontAwesomeIcon icon={faFileExport} className="ms-2"/>
                                </button>
                            </div>
                        }
                    </div>
                    {sub_users.length > 0 && <div className="sub-users-list my-4 ms-4">
                        <div className="btn-group w-100">
                            <button type="button" className="form-select dropdown-toggle dropdown-toggle-n actions-btn" data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="ms-2">{userFilter?.attributes?.email || "Filter by user"}</span>
                            </button>

                            <ul className="dropdown-menu w-100">
                                <li>
                                    <Button className='dropdown-item' clickHandler={()=>handleUserFilter({id: "ownerId", attributes: {email: email}})}>
                                        <span className="filter-span">{email}</span>
                                    </Button>
                                </li>
                                {sub_users.map((sub_user, index) => {
                                    return <li key={index}>
                                        <Button className='dropdown-item' clickHandler={()=>handleUserFilter(sub_user)}>
                                            <span className="filter-span">{sub_user?.attributes?.email}</span>
                                        </Button>
                                    </li>
                                })}
                            </ul>
                        </div>
                        {userFilter &&
                        <Button className='btn btn-tr p-0 mx-2' clickHandler={clearUserFilter}>
                            <FontAwesomeIcon icon={faXmark} className="ms-2"/>
                        </Button>}
                    </div>}
                </div>

                <div className="col-sm-6 my-4">
                    <div className="accounts-list dates-list position-relative d-flex">
                        <button type="button" className="form-select dropdown-toggle dropdown-toggle-n actions-btn dates-btn" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                            <span className="ms-2">{formatter_alt(startDate)} - {formatter_alt(endDate)}</span>
                        </button>
                            <div className="dropdown-menu w-100 dropdown-menu-end dates-selector" ref={dropdownRef}>
                                <DateRangePicker
                                    onChange={handleSelect}
                                    showDateDisplay={false}
                                    editableDateInputs={false}
                                    rangeColors={['#2bae76']}
                                    showMonthAndYearPickers={false}
                                    inputRanges={[]}
                                    weekStartsOn={week_starts_on}
                                    ranges={range}
                                    staticRanges={defaultStaticRanges(week_starts_on).slice(2)}
                                />
                            </div>
                    </div>
                </div>
            </div>


            <div className="row my-2">
                {data[0]?.total_comments > 0 && totalData && totalData.map((d, index) => {
                    if (userFilter && ["Total comments", "Total visible"].includes(d.name)){
                        return null
                    }else{
                        return <div key={index} className="col-xs-6 col-sm-3">
                            <div className="card">
                                <div className="card-body">
                                    <p className="card-text">{d.name}</p>
                                    <h3 className="card-title">{d.value}</h3>
                                </div>
                            </div>
                        </div>
                    }


                })}
            </div>

            {data[0]?.data?.length > 0 &&
                <>
                {data[0]?.total_comments > 0 &&
                    <div className="mt-8 area">

                        <ResponsiveBar
                            data={data[0].data}
                            keys={userFilter ? ["Hidden", "Deleted"] : keys}
                            indexBy="date"
                            margin={{ top: 60, right: 20, bottom: 70, left: 40 }}
                            padding={0.2}
                            valueScale={{ type: 'linear' }}
                            indexScale={{ type: 'band', round: true }}
                            colors={userFilter ? ['#2bae76', '#f47560'] : colors}
                            borderColor={{
                                from: 'color',
                                modifiers: [
                                    [
                                        'darker',
                                        1.6
                                    ]
                                ]
                            }}
                            axisTop={null}
                            axisRight={null}
                            axisBottom={{
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: isMobile ? -90 : 0,
                                legendPosition: 'middle',
                                legendOffset: 32,
                                truncateTickAt: 15,
                                format: (val) => {
                                    if(data[0]?.data?.length > 10){
                                        return timeScaleTicks.includes(formatter(new Date(val))) ? formatter(new Date(val)) : ''
                                    }else{
                                        return formatter(new Date(val))
                                    }
                                }
                            }}

                            axisLeft={{
                                format: (e) => (Math.floor(e) === e ? e : ""),
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0,
                                legendPosition: 'middle',
                                legendOffset: -40,
                                truncateTickAt: 0
                            }}
                            labelSkipWidth={12}
                            labelSkipHeight={12}
                            labelTextColor={{
                                from: 'color',
                                modifiers: [
                                    [
                                        'darker',
                                        1.6
                                    ]
                                ]
                            }}
                            legends={[
                                {
                                    dataFrom: 'keys',
                                    // data: keys.map((id, index) => ({
                                    //         color: legend_colors[index],
                                    //         id,
                                    //         label: data[0] && `${id}: ${data[0][id]}`
                                    //     })),
                                    anchor: 'top-left',
                                    direction: 'row',
                                    justify: false,
                                    translateX: 0,
                                    translateY: -55,
                                    itemsSpacing: 2,
                                    itemWidth: 100,
                                    itemHeight: 20,
                                    itemDirection: 'left-to-right',
                                    itemOpacity: 0.85,
                                    symbolSize: 20,
                                    effects: [
                                        {
                                            on: 'hover',
                                            style: {
                                                itemOpacity: 1
                                            }
                                        }
                                    ]
                                }
                            ]}
                            tooltip={({
                                          id,
                                          indexValue,
                                          value,
                                          color,
                                          label
                                      }) => <><div style={{background: 'white', color: 'inherit', fontSize: 13, borderRadius: 2, boxShadow: 'rgba(0, 0, 0, 0.25) 0px 1px 2px', padding: '5px 9px'}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <span style={{display: "block", width: "12px", height: "12px", background: color, marginRight: "7px"}}></span>
                                    <span>{id} - {formatter_alt(new Date(indexValue))}: <strong>{value}</strong></span>
                                </div>
                                </div></>
                        }

                        />

                    </div>}

                <div className="replies-section">

                    <div className="fw-bold my-4">Replies</div>
                    <div className="line my-4"/>

                    <div className="row mb-4">
                        <div className="col-xs-6 col-sm-3">
                            <div className="card">
                                <div className="card-body">
                                    <p className="card-text">Total replies sent</p>
                                    <h3 className="card-title">{data[0].replies?.total || 0}</h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    {data[0].replies?.total > 0 &&<div className="replies-stat">
                        <div className="row my-2">
                            <div className="col-6 col-sm-4">
                                Replied-by:
                            </div>
                            <div className="col-3 col-sm-2 num">
                                Replies
                            </div>
                            <div className="col-3 col-sm-2 avg">
                                Avg. response time
                            </div>
                            <div className="line my-2"/>
                        </div>


                        {data[0].replies?.data && data[0].replies.data.map((r, index) => {
                            return <div key={index} className="row my-2">
                                <div className="accordion accordion-flush" id={`flush_${index}`}>
                                    <div className="accordion-header row" id={`heading_${index}`}>
                                        <div className="col-6 col-sm-4">
                                        <button className="accordion-button a-accordion-button collapsed p-0" type="button"
                                                data-bs-toggle="collapse" data-bs-target={`#flush-collapse_${index}`}
                                                aria-expanded="false" aria-controls={`flush-collapse_${index}`}>
                                                {r._id.replace("Rule", "Automation").replace("Brand", "Agent")}
                                        </button>
                                        </div>
                                        <div className="col-3 col-sm-2 num">
                                            {r.count}
                                        </div>
                                        <div className="col-3 col-sm-2 avg">
                                            {tickFormat(r.avg)}
                                        </div>
                                        <div id={`flush-collapse_${index}`} className="accordion-collapse collapse"
                                             aria-labelledby={`heading_${index}`} data-bs-parent={`#flush_${index}`}>
                                            <div className="accordion-body px-0">
                                                {r.names.map((name, i) => {
                                                    return <div key={i} className="row py-2">
                                                        <div className="col-6 col-sm-4">
                                                            {name.name.replace(/Replied by: |Auto-reply: |Agent-reply: /g, "")}
                                                        </div>
                                                        <div className="col-3 col-sm-2 num">
                                                            {name.count}
                                                        </div>
                                                        <div className="col-3 col-sm-2 avg">
                                                            {tickFormat(name.avg)}
                                                        </div>
                                                    </div>
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="line my-2"/>
                            </div>

                        })}

                    </div>}

                </div>

                {showExportModal &&
                <ModalWindow hideClose={true} header="Export insights" closeHandler={() => setShowExportModal(false)}>
                    {/*<div className="mb-4">*/}
                    {/*    All comments within your current tab and/or filter will be exported.*/}
                    {/*</div>*/}
                    {load ?
                        <div className="mb-4">
                            Generating export...
                        </div>
                        : <form onSubmit={handleExport} ref={exportForm}>
                            <div className="mb-4">
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="radio" ref={directType} name="export_type"
                                           id="flexRadioDefault1" value="direct" defaultChecked={true}/>
                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                        Direct download
                                    </label>
                                    <div className="mt-1 fs-08">Download the export directly to your device.</div>
                                </div>
                                <div className="form-check my-2">
                                    <input className="form-check-input" type="radio" name="export_type" id="flexRadioDefault2"
                                           value="email"/>
                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                        Via email
                                    </label>
                                    <div className="mt-1 fs-08">Receive a link to download the export via email.</div>
                                </div>
                            </div>
                            <div>
                                <input type="hidden" name="page_id" value={pageId}/>
                                <input type="hidden" name="user_id" value={userFilter?.id}/>
                                <button type="submit" className="btn btn-primary float-end">Export</button>
                                <button type="reset" className="btn btn-tr float-end mx-2"
                                        onClick={() => setShowExportModal(false)}>Cancel</button>
                            </div>
                        </form>}
                </ModalWindow>
                }
                </>
            }
        </div>
    )
}

export default React.memo(Analytics)